import { Tooltip, Popover, Input, Table, TableColumn, Dropdown, DropdownItem, DropdownMenu, Select, Option } from 'element-ui'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {

    install(Vue) {

        // ELEMENT UI.

        // Plugins.        
        Vue.use(Tooltip);
        Vue.use(Popover);

        // Components.
        Vue.component('el-input', Input);
        Vue.component('el-table', Table);
        Vue.component('el-table-column', TableColumn);
        Vue.component('el-dropdown', Dropdown);
        Vue.component('el-dropdown-item', DropdownItem);
        Vue.component('el-dropdown-menu', DropdownMenu);
        Vue.component('el-popover', Popover);
        Vue.component('el-select', Select);
        Vue.component('el-option', Option);

        
        // VEE VALIDATE.

        Vue.component('validation-provider', ValidationProvider)
        Vue.component('validation-observer', ValidationObserver)


        // ARGON PRO.

        // Plugins.        
        Vue.use(require('@tim/argon-pro/src/components/NotificationPlugin').default);

        // Components.
        Vue.component('badge', require('@tim/argon-pro/src/components/Badge.vue').default);
        Vue.component('base-alert', require('@tim/argon-pro/src/components/BaseAlert.vue').default);
        Vue.component('base-button', require('@tim/argon-pro/src/components/BaseButton.vue').default);
        Vue.component('base-dropdown', require('@tim/argon-pro/src/components/BaseDropdown.vue').default);
        Vue.component('base-header', require('@tim/argon-pro/src/components/BaseHeader.vue').default);
        Vue.component('base-progress', require('@tim/argon-pro/src/components/BaseProgress.vue').default);
        Vue.component('base-table', require('@tim/argon-pro/src/components/BaseTable.vue').default);
        //Vue.component('button-checkbox', require('@tim/argon-pro/src/components/ButtonCheckbox.vue').default);
        //      Breadcrumb
        Vue.component('breadcrumb', require('@tim/argon-pro/src/components/Breadcrumb/Breadcrumb.vue').default);
        Vue.component('breadcrumb-item', require('@tim/argon-pro/src/components/Breadcrumb/BreadcrumbItem.vue').default);
        //      Cards
        Vue.component('card', require('@tim/argon-pro/src/components/Cards/Card.vue').default);
        //      Inputs
        Vue.component('base-checkbox', require('@tim/argon-pro/src/components/Inputs/BaseCheckbox.vue').default);
        Vue.component('base-input', require('@tim/argon-pro/src/components/Inputs/BaseInput.vue').default);
        Vue.component('base-radio', require('@tim/argon-pro/src/components/Inputs/BaseRadio.vue').default);
        //      Navbar
        Vue.component('base-nav', require('@tim/argon-pro/src/components/Navbar/BaseNav.vue').default);
        //      Tabs
        Vue.component('tab-pane', require('@tim/argon-pro/src/components/Tabs/Tab.vue').default);
        

        // LOCAL.

        // New components.
        Vue.component('clickable-image', require('./app/components/ClickableImage.vue').default);
        Vue.component('loading-more', require('./app/components/LoadingMore.vue').default);
        Vue.component('editor', require('./app/components/Editor.vue').default);
        Vue.component('back-to-top', require('./app/components/BackToTop.vue').default);
        Vue.component('base-select', require('./app/components/Inputs/BaseSelect.vue').default);
        Vue.component('dropzone', require('./app/components/Inputs/Dropzone.vue').default);
        Vue.component('drawing', require('./app/components/Inputs/DrawingModal.vue').default);
        Vue.component('camera', require('./app/components/Inputs/CameraModal.vue').default);
        Vue.component('file-picker', require('./app/components/Inputs/FilePicker.vue').default);
        Vue.component('table-control', require('./app/components/TableControl.vue').default);
        Vue.component('table-pagination', require('./app/components/TablePagination.vue').default);
        Vue.component('collapse-item-card', require('./app/components/Collapse/CollapseItemCard.vue').default);
        Vue.component('time-input', require('./app/components/Inputs/TimeInput.vue').default);
        Vue.component('date-input', require('./app/components/Inputs/DateInput.vue').default);
        Vue.component('actions-dropdown', require('./app/components/ActionsDropdown.vue').default);
        Vue.component('file-importer', require('./app/components/FileImporter.vue').default);
        //      Modals
        Vue.component('base-modal', require('./app/components/Modals/BaseModal.vue').default);
        Vue.component('confirm-modal', require('./app/components/Modals/ConfirmModal.vue').default);
        Vue.component('error-modal', require('./app/components/Modals/ErrorModal.vue').default);
        Vue.component('success-modal', require('./app/components/Modals/SuccessModal.vue').default);
        Vue.component('form-modal', require('./app/components/Modals/FormModal.vue').default);

        // Adaptated from Argon
        Vue.component('base-pagination', require('./app/components/BasePagination.vue').default);
        Vue.component('base-switch', require('./app/components/BaseSwitch.vue').default);
        Vue.component('button-checkbox', require('./app/components/ButtonCheckbox.vue').default);
        Vue.component('button-radio-group', require('./app/components/ButtonRadioGroup.vue').default);
        //      Nav
        Vue.component('top-navbar', require('./app/layout/parts/TopNavbar.vue').default);
        //      Collapse
        Vue.component('collapse', require('./app/components/Collapse/Collapse.vue').default);
        Vue.component('collapse-item', require('./app/components/Collapse/CollapseItem.vue').default);
        //      Inputs
        Vue.component('base-input', require('./app/components/Inputs/BaseInput.vue').default);
        Vue.component('file-input', require('./app/components/Inputs/FileInput.vue').default);
        //      Modals
        Vue.component('modal', require('./app/components/Modals/Modal.vue').default);
        //      Tabs
        Vue.component('tabs', require('./app/components/Tabs/Tabs.vue').default);
        //      Directives.
        Vue.directive('click-outside', require('./app/directives/click-ouside.js').default);
    }
}
